module.exports = __webpack_public_path__ + "static/media/go-school.f3d14bde.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/common/go-school.png
// module id = 258
// module chunks = 146